import Vue from 'vue'
import Router from 'vue-router'
import NavBar from '@/components/NavBar.vue'
import detail from "./detail"; // 详情页面

Vue.use(Router)
/**
 * 全屏页面
 */
const other = [

]
/**
 * 导航页面
 */
const Main = [
  {
    path: '/', redirect: '/homepage', name: 'homepage', meta: { title: '首页' ,icon: 'el-icon-location' ,}, component: NavBar, isRoot: true,
    children: [
      { path: '/homepage', name: 'homepage-index', component: () => import('@/ivews/homepage/index.vue'), hidden: false, meta: { title: '首页' } },
    ]
  },
  {
    path: 'scheme', redirect: '/Visual',   name: 'scheme', meta: { title: '数字供应链服务' ,icon: 'el-icon-location' ,}, component: NavBar, isRoot: true,
    children: [
      { path: '/Visual', name: 'scheme-Visual', component: () => import('@/ivews/scheme/Visual.vue'), hidden: false, meta: { title: '货物跟踪可视化服务' } },
      { path: '/Paperless', name: 'scheme-Paperless', component: () => import('@/ivews/scheme/Paperless.vue'), hidden: false, meta: { title: '物流全程无纸化' } },
      { path: '/Management', name: 'scheme-Management', component: () => import('@/ivews/scheme/Management.vue'), hidden: false, meta: { title: '物流数字化  无纸化服务' } },
      { path: '/Digitization', name: 'scheme-Digitization', component: () => import('@/ivews/scheme/Digitization.vue'), hidden: false, meta: { title: '企业管理数据化驾驶舱' } }
    ]
  },
  {
    path: 'case', redirect: '/FMCG',   name: 'case', meta: { title: '行业案例' ,icon: 'el-icon-location' ,}, component: NavBar, isRoot: true,
    children: [
      { path: '/FMCG', name: 'case-FMCG', component: () => import('@/ivews/case/FMCG.vue'), hidden: false, meta: { title: '快消品' } },
      { path: '/Medicine', name: 'case-Medicine', component: () => import('@/ivews/case/Medicine.vue'), hidden: false, meta: { title: '冷链医药' } },
      { path: '/Intelligent', name: 'case-Intelligent', component: () => import('@/ivews/case/Intelligent.vue'), hidden: false, meta: { title: '智能制造' } },
      { path: '/Tripartite', name: 'case-Tripartite', component: () => import('@/ivews/case/Tripartite.vue'), hidden: false, meta: { title: '三方物流' } },
      { path: '/Bulk', name: 'case-Bulk', component: () => import('@/ivews/case/Bulk.vue'), hidden: false, meta: { title: '大宗物流' } }
    ]
  },
  {
    path: '/support', redirect: '/support', name: 'support', meta: { title: '服务与支持' ,icon: 'el-icon-location' ,}, component: NavBar, isRoot: true,
    children: [
      { path: '/support', name: 'support', component: () => import('@/ivews/support/Support.vue'), hidden: false, meta: { title: '服务与支持' } },
    ]
  },
  {
    path: '/aboutUsUs', redirect: '/aboutUsUs', name: 'aboutUsUs', meta: { title: '关于我们' ,icon: 'el-icon-location' ,}, component: NavBar, isRoot: true,
    children: [
      { path: '/aboutUsUs', name: 'aboutUsUs', component: () => import('@/ivews/aboutUsUs/AboutUsUs.vue'), hidden: false, meta: { title: '关于我们' } },
    ]
  }
]

export default new Router({
  routes: [
    // ...other,
    ...Main,
    ...detail
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js